<template>
  <div>
    <span v-if="small">
      <strong><router-link :to="{name: 'queue'}">Stats</router-link></strong>
      Workers: {{queue.workers}} /
      Free: {{freeSlots}} /
      Occupied: {{queue.started_jobs}} /
      Queued: {{queue.jobs}}
    </span>
    <v-card v-else>
      <v-card-title>
      <h1 class="title">Worker Stats</h1>
      </v-card-title>

      <v-card-text>
        <p>
          Total Number of workers available: <strong>{{queue.workers}}</strong><br />
          Of those:<br />
          Free: <strong>{{freeSlots}}</strong><br />
          Occupied: <strong>{{queue.started_jobs}}</strong><br />
          Number of jobs enqueued (waiting): <strong>{{queue.jobs}}</strong>
        </p>
      </v-card-text>
    </v-card>
  </div>
</template>
<script>
  export default {
    name: 'queue-stats',
    props: {
      small: {
        default: false,
      },
    },
    mounted() {
      this.$store.dispatch('fetchQueueStat');
    },
    computed: {
      queue() {
        return this.$store.getters.queueStat;
      },
      freeSlots() {
        const freeSlots = this.queue.workers - this.queue.started_jobs;
        return (freeSlots > -1) ? freeSlots : 0;
      },
      queues() {
        return [
          {
            Workers: this.queue.workers,
            Free: this.freeSlots,
            Occupied: this.queue.started_jobs,
            Queued: this.queue.jobs,
          },
        ];
      },
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/QueueStats.vue